define(
    'connections/search-suggestions-connection',[
        'jquery',

        'utils/ajax-util',

        'settings',
    ],

    function ($, ajax, settings) {
        /**
         * @class SearchSuggestions
         */
        return (function () {

            /**
             * @constructor
             */
            function SearchSuggestionsConnection () {}

            /**
             * Property used to check if the view is up to date
             *
             * @property searchSuggestionsViewLoaded
             * @type {boolean}
             */
            SearchSuggestionsConnection.prototype.searchSuggestionsViewLoaded = false;

            SearchSuggestionsConnection.prototype.setSearchSuggestionsViewLoaded = function(isLoaded) {
                var _this = this;

                return function() {
                    _this.searchSuggestionsViewLoaded = isLoaded;
                };
            };

            /**
             * Get the partial view
             *
             * @method getSearchSuggestions
             * @returns {*}
             */
            SearchSuggestionsConnection.prototype.getSearchSuggestions = function(q) {
                var _this = this;

                return $.ajax({
                    url: settings.productLiveSearchUrl + '?q=' + q,
                    type: 'GET',
                    cache: false,
                    success: function() {
                        _this.setSearchSuggestionsViewLoaded(true);
                    }
                });
            };

            return new SearchSuggestionsConnection();
        })();
    }
);

